export enum CcHpiConstants {
  SET_CHIEF_COMPLAINT = 'ccHpi/SET_CHIEF_COMPLAINT',
  SET_PATIENT_ACTIVITY = 'ccHpi/SET_PATIENT_ACTIVITY',
  SET_REASON_FOR_ENCOUNTER = 'ccHpi/SET_REASON_FOR_ENCOUNTER',
  SET_DRUGS_AND_ALCOHOL = 'ccHpi/SET_DRUGS_AND_ALCOHOL',
  SET_DRUGS_AND_ALCOHOL_INDICATORS = 'ccHpi/SET_DRUGS_AND_ALCOHOL_INDICATORS',
  SET_DRUGS_AND_ALCOHOL_INDICATORS_PNNV = 'ccHpi/SET_DRUGS_AND_ALCOHOL_INDICATORS_PNNV',
  SAVE_CC_HPI = 'ccHpi/SAVE_CC_HPI',
  SET_SITUATION_STATE = 'ccHpi/SET_SITUATION_STATE',
  RESET_SITUATION_STATE = 'ccHpi/RESET_SITUATION_STATE',
  SET_HISTORY_STATE = 'ccHpi/SET_HISTORY_STATE',
  RESET_HISTORY_STATE = 'ccHpi/RESET_HISTORY_STATE',
  SET_ARREST_PRESENT = 'ccHpi/SET_ARREST_PRESENT',
  SET_ARREST_PRESENT_PNNV = 'ccHpi/SET_ARREST_PRESENT_PNNV',
  SET_DTWITNESSED = 'ccHpi/SET_DTWITNESSED',
  SET_DTWITNESSED_PNNV = 'ccHpi/SET_DTWITNESSED_PNNV',
  SET_UNK_WITNESSED = 'ccHpi/SET_UNK_WITNESSED',
  SET_WHO_WITNESSED = 'ccHpi/SET_WHO_WITNESSED',
  SET_ETIOLOGY = 'ccHpi/SET_ETIOLOGY',
  SET_ETIOLOGY_PNNV = 'ccHpi/SET_ETIOLOGY_PNNV',
  SET_THERAPEUTIC_HYPOTHERMIA = 'ccHpi/SET_THERAPEUTIC_HYPOTHERMIA',
  SET_INITIAL_RHYTHM = 'ccHpi/SET_INITIAL_RHYTHM',
  SET_INITIAL_RHYTHM_PNNV = 'ccHpi/SET_INITIAL_RHYTHM_PNNV',
  SET_CPR_PRIOR_EMS_ARRIVAL = 'ccHpi/SET_CPR_PRIOR_EMS_ARRIVAL',
  SET_CPR_PRIOR_EMS_ARRIVAL_PNNV = 'ccHpi/SET_CPR_PRIOR_EMS_ARRIVAL_PNNV',
  SET_FIRST_CPR = 'ccHpi/SET_FIRST_CPR',
  SET_FIRST_CPR_PNNV = 'ccHpi/SET_FIRST_CPR_PNNV',
  SET_DTCPR = 'ccHpi/SET_DTCPR',
  SET_UNK_CPR = 'ccHpi/SET_UNK_CPR',
  SET_CPRBY = 'ccHpi/SET_CPRBY',
  SET_CPRTYPE = 'ccHpi/SET_CPRTYPE',
  SET_RESUSCITATION = 'ccHpi/SET_RESUSCITATION',
  SET_AED_USE = 'ccHpi/SET_AED_USE',
  SET_FIRST_AED_BY = 'ccHpi/SET_FIRST_AED_BY',
  SET_FIRST_AED_BY_PNNV = 'ccHpi/SET_FIRST_AED_BY_PNNV',
  SET_AED_BY = 'ccHpi/SET_AED_BY',
  SET_DTDEFIB = 'ccHpi/SET_DTDEFIB',
  SET_UNK_DEFIB = 'ccHpi/SET_UNK_DEFIB',
  SET_DEFIB_TYPE = 'ccHpi/SET_DEFIB_TYPE',
  SET_DEFIB_BY = 'ccHpi/SET_DEFIB_BY',
  SET_DEFIB_BY_PNNV = 'ccHpi/SET_DEFIB_BY_PNNV',
  SET_DTALS = 'ccHpi/SET_DTALS',
  SET_UNK_ALS = 'ccHpi/SET_UNK_ALS',
  SET_DTDISC = 'ccHpi/SET_DTDISC',
  SET_UNK_DISC = 'ccHpi/SET_UNK_DISC',
  SET_DISC_REASON = 'ccHpi/SET_DISC_REASON',
  SET_DISC_REASON_PNNV = 'ccHpi/SET_DISC_REASON_PNNV',
  SET_DTCIRCULATION = 'ccHpi/SET_DTCIRCULATION',
  SET_UNK_CIRCUALATION = 'ccHpi/SET_UNK_CIRCUALATION',
  SET_RETURN_CIRCULATION = 'ccHpi/SET_RETURN_CIRCULATION',
  SET_DTVENT = 'ccHpi/SET_DTVENT',
  SET_UNK_VENT = 'ccHpi/SET_UNK_VENT',
  SET_DEST_RHYTHM = 'ccHpi/SET_DEST_RHYTHM',
  SET_DEST_RHYTHM_PNNV = 'ccHpi/SET_DEST_RHYTHM_PNNV',
  SET_ARREST_RESULT = 'ccHpi/SET_ARREST_RESULT',
  SET_CARDIAC_ARREST_STATE = 'ccHpi/SET_CARDIAC_ARREST_STATE',
  RESET_CARDIAC_ARREST_STATE = 'ccHpi/RESET_CARDIAC_ARREST_STATE',
  SAVE_CARDIAC_ARREST = 'ccHpi/SAVE_CARDIAC_ARREST',
  SET_CARDIAC_ARREST_DEFAULTS = 'ccHpi/SET_CARDIAC_ARREST_DEFAULTS',
  SET_INTENTIONAL = 'ccHpi/SET_INTENTIONAL',
  SET_TRAUMA_TRIAGE_CRITERIA_HIGH_RISK = 'ccHpi/SET_TRAUMA_TRIAGE_CRITERIA_HIGH_RISK',
  SET_TRAUMA_TRIAGE_CRITERIA_HIGH_RISK_PNNV = 'ccHpi/SET_TRAUMA_TRIAGE_CRITERIA_HIGH_RISK_PNNV',
  SET_TRAUMA_TRIAGE_CRITERIA_MODERATE_RISK = 'ccHpi/SET_TRAUMA_TRIAGE_CRITERIA_MODERATE_RISK',
  SET_TRAUMA_TRIAGE_CRITERIA_MODERATE_RISK_PNNV = 'ccHpi/SET_TRAUMA_TRIAGE_CRITERIA_MODERATE_RISK_PNNV',
  SET_INJURY_CAUSE = 'ccHpi/SET_INJURY_CAUSE',
  SET_MECHANISM = 'ccHpi/SET_MECHANISM',
  SET_MECHANISM_PNNV = 'ccHpi/SET_MECHANISM_PNNV',
  SET_SAFETY_EQUIPMENT = 'ccHpi/SET_SAFETY_EQUIPMENT',
  SET_SAFETY_EQUIPMENT_PNNV = 'ccHpi/SET_SAFETY_EQUIPMENT_PNNV',
  SET_FALL_HEIGHT = 'ccHpi/SET_FALL_HEIGHT',
  SET_FALL_SURFACE = 'ccHpi/SET_FALL_SURFACE',
  SET_LANDED_ON = 'ccHpi/SET_LANDED_ON',
  SET_WORK_RELATED = 'ccHpi/SET_WORK_RELATED',
  SET_WORK_RELATED_PNNV = 'ccHpi/SET_WORK_RELATED_PNNV',
  SET_CCHPI_INJURY_DETAILS = 'ccHpi/SET_CCHPI_INJURY_DETAILS',
  RESET_CCHPI_INJURY_DETAILS = 'ccHpi/RESET_CCHPI_INJURY_DETAILS',
  SET_CCDURATION = 'ccHpi/SET_CCDURATION',
  SET_CCDURATION_UNIT = 'ccHpi/SET_CCDURATION_UNIT',
  SET_SCDURATION = 'ccHpi/SET_SCDURATION',
  SET_SCDURATION_UNIT = 'ccHpi/SET_SCDURATION_UNIT',
  SET_OCDURATION = 'ccHpi/SET_OCDURATION',
  SET_OCDURATION_UNIT = 'ccHpi/SET_OCDURATION_UNIT',
  SET_SECONDARY_COMPLAINT = 'ccHpi/SET_SECONDARY_COMPLAINT',
  SET_OTHER_COMPLAINTS = 'ccHpi/SET_OTHER_COMPLAINTS',
  SET_OTHER_COMPLAINT = 'ccHpi/SET_OTHER_COMPLAINT',
  SET_SEGMENT = 'ccHpi/SET_SEGMENT',
  SET_ALS_ASSESSMENT_RATIONALE = 'ccHpi/SET_ALS_ASSESSMENT_RATIONALE',
  SET_ALS_ASSESSMENT = 'ccHpi/SET_ALS_ASSESSMENT',
  SET_CCHPI_DEFAULTS = 'ccHpi/SET_DEFAULTS',
}
